module.exports = __webpack_public_path__ + "img/intro_no.bc508de0.svg";